export const adaptPersonDetail = (data: IPersonProfile): PersonDetail => {
	return {
		socialProfile: data.social_profile
			? {
					jobTitle: data.social_profile.job_title,
					orgTeamLevelOne: data.social_profile.org_team_level_one,
					orgTeamLevelTwo: data.social_profile.org_team_level_two,
					orgTeamLevelThree: data.social_profile.org_team_level_three,
					preferredFeed: data.social_profile.preferred_feed,
					subscribedFeeds: data.social_profile.subscribed_feeds,
					meeGroups: data.social_profile.mee_groups
				}
			: null,
		authUser: data.auth_user
			? {
					id: data.auth_user.id,
					username: data.auth_user.username,
					lastLogin: data.auth_user.last_login,
					dateJoined: data.auth_user.date_joined
				}
			: null
	};
};
